import { post, postExFile } from "@utils/httpUtil";
// 处方单管理-分页查询社区处方单列表
export function contentLabelSaveOrUpdate(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/content/label/saveOrUpdate`, data, config);
}
export function contentLabelGetList(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/content/label/getList`, data, config);
}
export function contentLabelGetPageInfo(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/content/label/getPageInfo`, data, config);
}
export function contentLabelDelete(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/content/label/delete`, data, config);
}
// 内容创作 - 创作列表;
export function contentGetPageInfo(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/content/getPageInfo`, data, config);
}
export function contentPublishCancel(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/content/publishCancel`, data, config);
}
export function contentBatchDelete(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/content/batchDelete`, data, config);
}
export function contentExportData(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return postExFile(`/c/pc/community/content/exportData`, data, config);
}
export function contentAuthorSaveOrUpdate(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/content/author/saveOrUpdate`, data, config);
}
//内容作者管理-列表P[[-=-[P-P]]]
export function contentAuthorGetList(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/content/author/getList`, data, config);
}
export function contentAuthorGetPageInfo(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/content/author/getPageInfo`, data, config);
}
export function contentAuthorDelete(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/content/author/delete`, data, config);
}
export function contentPublishContent(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/content/publishContent`, data, config);
}
export function contentGetContentDetail(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/content/getContentDetail`, data, config);
}
export function contentDraftContent(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/content/draftContent`, data, config);
}

// 分页查询内容管理列表
export function articleManageList(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/articleManage/pageList`, data, config);
}
// 批量打标签
export function articleManageBatchAddLabel(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/articleManage/batchAddLabel`, data, config);
}
// 批量操作上架、下架
export function articleManageBatchUpdateShelfStatus(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/articleManage/batchUpdateShelfStatus`, data, config);
}
// 批量操作显示、隐藏
export function batchUpdateShowStatus(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/articleManage/batchUpdateShowStatus`, data, config);
}
// 批量操作互动区开启、关闭
export function batchUpdateInteractiveStatus(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/doctor/community/content/articleManage/batchUpdateInteractiveStatus`, data, config);
}
// 更新文章可见权限
export function updateVisibleType(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/doctor/community/content/articleManage/updateVisibleType`, data, config);
}
// 更新医生专题内容可见权限
export function modifyVisibleType(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/doctor/community/subject/modify/visibleType`, data, config);
}
// 内容管理导出列表数据
export function articleManageListExport(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return postExFile(`/c/pc/articleManage/export`, data, config);
}
// 查询社区内容设置
export function getCommunityContentConfig(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/articleManage/getCommunityContentConfig`, data, config);
}
// 保存社区内容设置
export function saveCommunityContentConfig(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/articleManage/saveCommunityContentConfig`, data, config);
}
// 修改内容标签
export function articleManageUpdateArticleLabel(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/articleManage/updateArticleLabel`, data, config);
}
// 修改内容标签
export function articleManageUpdateArticleClass(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/articleManage/updateArticleGroup`, data, config);
}
// 修改内容标签
export function articleManageUpdateArticleClassGroup(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/articleManage/batchAddGroup`, data, config);
}

// 内容标签tree
export function articleManageLabelList(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/content/label/getList`, data, config);
}
// 下啦查询内容管理列表
export function selectContentConfigPageList(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/articleManage/contentConfigPageList`, data, config);
}
// 分页查询活动文章列表
export function activityArticlePageList(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/activityArticle/pageList`, data, config);
}
// 内容活动列表导出列表数据
export function activityArticleExportData(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return postExFile(`/c/pc/activityArticle/exportData`, data, config);
}
// 内容活动列表删除
export function activityArticleBatchDelete(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/activityArticle/batchDelete`, data, config);
}
// 内容活动列表-内容详情
export function activityArticleGetArticleDetail(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/activityArticle/getArticleDetail`, data, config);
}
// 内容活动列表-编辑
export function activityArticleUpdateArticleDetail(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/activityArticle/updateArticleDetail`, data, config);
}
// 医生专业社区
//  医生专业社区-内容创作 - 创作列表;
export function doctorContentGetPageInfo(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/doctor/community/content/creation/getPageInfo`, data, config);
}
export function doctorContentBatchDelete(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/doctor/community/content/creation/batchDelete`, data, config);
}
export function doctorContentPublishCancel(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/doctor/community/content/creation/publishCancel`, data, config);
}
export function doctorContentExportData(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return postExFile(`/c/pc/doctor/community/content/creation/exportData`, data, config);
}
export function doctorContentPublishContent(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/doctor/community/content/creation/publishContent`, data, config);
}
export function doctorContentDraftContent(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/doctor/community/content/creation/draftContent`, data, config);
}
export function getdoctorContentDetail(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/doctor/community/content/creation/getContentDetail`, data, config);
}
// 医生专业社区-内容作者管理
export function doctorContentAuthorGetList(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/doctor/community/content/author/getList`, data, config);
}
export function doctorContentAuthorGetPageInfo(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/doctor/community/content/author/getPageInfo`, data, config);
}
export function doctorContentAuthorDelete(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/doctor/community/content/author/author/delete`, data, config);
}
export function doctorContentAuthorSaveOrUpdate(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/doctor/community/content/author/saveOrUpdate`, data, config);
}
//医生专业社区- 内容标签管理
export function doctorContentLabelGetList(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/doctor/community/content/label/getList`, data, config);
}
export function doctorContentLabelGetPageInfo(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/doctor/community/content/label/getPageInfo`, data, config);
}
export function doctorContentLabelDelete(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/doctor/community/content/label/delete`, data, config);
}
export function doctorContentLabelSaveOrUpdate(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/doctor/community/content/label/saveOrUpdate`, data, config);
}
// 医生专业社区- 内容列表管理
export function doctorArticleManageList(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/doctor/community/content/articleManage/pageList`, data, config);
}
export function doctorArticleManageBatchAddLabel(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/doctor/community/content/articleManage/batchAddLabel`, data, config);
}
export function doctorArticleManageBatchUpdateShelfStatus(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/doctor/community/content/articleManage/batchUpdateShelfStatus`, data, config);
}
export function doctorBatchUpdateShowStatus(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/doctor/community/content/articleManage/batchUpdateShowStatus`, data, config);
}
export function doctorArticleManageListExport(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return postExFile(`/c/pc/doctor/community/content/articleManage/export`, data, config);
}
export function doctorArticleManageUpdateArticleLabel(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/doctor/community/content/articleManage/updateArticleLabel`, data, config);
}
export function doctorArticleManageCommentPageInfo(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/doctor/community/content/comment/getPageInfo`, data, config);
}
export function doctorArticleManageCommentDelete(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/doctor/community/content/comment/delete`, data, config);
}
// 医生-推广位ID查询推广位
export function doctorPromotionPositionFindById(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/doctor/community/content/community/promotionPosition/findById`, data, config || { ignoreError: true });
}
// 医生-推广位分页查询
export function doctorPromotionPositionFindPageByCondition(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/doctor/community/content/community/promotionPosition/findPageByCondition`, data, config || { ignoreError: true });
}
// 医生-查询社区推广位设置
export function doctorPromotionPositionGetConfig(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/doctor/community/content/community/promotionPosition/getConfig`, data, config || { ignoreError: true });
}
// 医生-添加修改推广位
export function doctorPromotionPositionSave(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/doctor/community/content/community/promotionPosition/save`, data, config);
}
// 医生-添加修改推广位校验
export function doctorPromotionPositionSaveCheck(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/doctor/community/content/community/promotionPosition/saveCheck`, data, config);
}
// 医生-编辑社区推广位设置
export function doctorPromotionPositionUpdateConfig(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/doctor/community/content/community/promotionPosition/updateConfig`, data, config || { ignoreError: true });
}
// 医生-修改推广位状态
export function doctorPromotionPositionUpdateStatus(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/doctor/community/content/community/promotionPosition/updateStatus`, data, config || { ignoreError: true });
}
// 医生-获取文章专题详情
export function doctorSubjectDetail(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/doctor/community/subject/detail`, data, config);
}
// 医生-获取文章专题列表
export function doctorSubjectList(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/doctor/community/subject/listV2`, data, config);
}
// 医生-新增文章专题
export function doctorSubjectCreate(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/doctor/community/subject/createV2`, data, config);
}
// 医生-修改文章专题
export function doctorSubjectModify(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/doctor/community/subject/modifyV2`, data, config);
}
// 医生-专题名称是否可用查询
export function doctorSubjectRemove(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/doctor/community/subject/remove`, data, config);
}
// 医生-删除文章专题
export function doctorSubjectTitleQuery(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/doctor/community/subject/titleQueryV2`, data, config);
}
// 医生-获取专题已关联文章列表
export function doctorRelationList(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/doctor/community/subject/article/relation/listV2`, data, config);
}
// 医生专业社区- 内容设置
export function getDoctorCommunityContentConfig(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/doctor/community/content/articleManage/getCommunityContentConfig`, data, config);
}
export function saveDoctorCommunityContentConfig(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/doctor/community/content/articleManage/saveCommunityContentConfig`, data, config);
}
// 下啦查询内容管理列表
export function doctorSelectContentConfigPageList(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/doctor/community/content/articleManage/contentConfigPageList`, data, config);
}
// 学科标签
export function doctorGetDeptTag(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/articleManager/deptTag`, data, config);
}

///////分页查询内容管理列表
export function specialTopicPageList(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/articleManage/pageList`, data, config);
}
///////
export function subjectCreate(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/community/subject/createV2`, data, config);
}
///////
export function subjectModify(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/community/subject/modifyV2`, data, config);
}
//获取文章专题详情
export function subjectDetail(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/community/subject/detail`, data, config);
}
//获取文章专题详情
export function subjectList(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/community/subject/listV2`, data, config);
}
//获取专题已关联文章列表
export function relationList(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/community/subject/article/relation/listV2`, data, config);
}
// 专题名称是否可用查询;
export function subjectTitleQuery(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/community/subject/titleQueryV2`, data, config);
}
// 上下线
export function modifyStatus(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/community/subject/modify/status`, data, config);
}
// 删除文章专题
export function subjectRemove(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/community/subject/remove`, data, config);
}
// 暂存
export function subjectStash(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/community/subject/stash`, data, config);
}
// 暂存
export function subjectGetStash(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/community/subject/getStash`, data, config);
}

//获取社区分类列表
export function pageCategory(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/medicine/category/pageArticleGroup`, data, config);
}
//新增/编辑 专题/文章类型
export function saveCategory(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/medicine/category/saveSaasArticleGroup`, data, config);
}
//更改排序
export function swapSort(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/medicine/category/swapSort`, data, config);
}
//删除分类
export function categoryDelete(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/medicine/category/delete`, data, config || { ignoreError: true });
}
//根据id查分类
export function categoryGetById(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/medicine/category/getArticleGroupList`, data, config || { ignoreError: true });
}
//分页查询计划内容分发记录列表
export function findPageByCondition(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/planContentDistributionRecord/findPageByCondition`, data, config || { ignoreError: true });
}

//查询社区推广位设置
export function promotionPositionGetConfig(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/promotionPosition/getConfig`, data, config || { ignoreError: true });
}

//编辑社区推广位设置
export function promotionPositionUpdateConfig(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/promotionPosition/updateConfig`, data, config || { ignoreError: true });
}

//推广位分页查询
export function promotionPositionFindPageByCondition(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/promotionPosition/findPageByCondition`, data, config || { ignoreError: true });
}

//添加修改推广位
export function promotionPositionSave(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/promotionPosition/save`, data, config);
}

//修改推广位状态
export function promotionPositionUpdateStatus(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/promotionPosition/updateStatus`, data, config || { ignoreError: true });
}

//添加修改推广位校验
export function promotionPositionSaveCheck(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/promotionPosition/saveCheck`, data, config || { ignoreError: true });
}

//推广位ID查询推广位
export function promotionPositionFindById(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/promotionPosition/findById`, data, config || { ignoreError: true });
}

//分页查询学术活动文章列表
export function doctorComtyactivityArticlePageList(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/dc/activityArticle/pageList`, data, config || { ignoreError: true });
}

//学术活动文章-批量删除
export function doctorComtyactivityArticleBatchDelete(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/dc/activityArticle/batchDelete`, data, config || { ignoreError: true });
}

//导出学术活动文章数据
export function doctorComtyactivityArticleExportData(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return postExFile(`/c/pc/dc/activityArticle/exportData`, data, config || { ignoreError: true });
}
